"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  path: 'https://assets2.lottiefiles.com/packages/lf20_ah1zbzo1.json',
  renderer: 'svg',
  speed: 1,
  forceUpdate: false,
  loop: true,
  isStopped: false,
  isPaused: false,
  height: '250px'
};
exports["default"] = _default;